// extracted by css-extract-rspack-plugin
export default {"loginAttributes":"EaW6O"};